<template>
  <div>
    <div class="step6__desc">
      Ngay sau khi khách hàng thực hiện ký hợp đồng, hệ thống<br />
      sẽ tự động giải ngân cho khách hàng.
    </div>
    <div class="step6">
      <div class="step6__box mt-4">
        <div class="step6__warning">⚠️ TRƯỜNG HỢP KHÁCH HÀNG HỦY HỢP ĐỒNG VAY CITIME</div>

        <ul class="step-bullets">
          <li>Vui lòng thực hiện các bước hủy hợp đồng theo quy trình.</li>
          <li>
            Sau khi hoàn tất, đánh dấu trạng thái khách hàng hủy hợp đồng để hệ thống dừng các bước nhắc nhở tiếp theo.
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "step6HandleFileContract",
  components: {
    result: '',
  },
  data() {
    return {

    }
  },

  mounted() {

  },

  methods: {

  }
}
</script>

<style scoped>
.step6 {
  text-align: left;
}

.step6__desc {
  line-height: 1.5;
}

/* Box cảnh báo giống kiểu khung nội dung */
.step6__box {
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 14px 16px;
  background: #fff;
  max-width: 860px;     /* desktop nhìn gọn */
  margin: 0 auto;       /* canh giữa */
}

.step6__warning {
  font-weight: 700;
  margin-bottom: 10px;
}

/* Bullet đẹp, không lệ thuộc inline margin-left */
.step-bullets {
  margin: 0;
  padding-left: 20px;
}

.step-bullets li {
  margin: 6px 0;
  line-height: 1.5;
}

/* ===== Responsive ===== */

/* Tablet */
@media (max-width: 992px) {
  .step6__box {
    max-width: 100%;
    padding: 12px 14px;
  }
}

/* Mobile */
@media (max-width: 576px) {
  .step6__desc br {
    display: none; /* mobile đỡ bị xuống dòng cứng */
  }

  .step6__box {
    padding: 12px;
    border-radius: 8px;
  }

  .step-bullets {
    padding-left: 18px;
  }
}
</style>



